import { render, staticRenderFns } from "./GenerateReport.vue?vue&type=template&id=d2a1860a"
import script from "./GenerateReport.vue?vue&type=script&lang=js"
export * from "./GenerateReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports